export default "__VITE_ASSET__9k0yE6A0__"